<h1 mat-dialog-title>{{ title }}</h1>

<mat-dialog-content>
  <form fxLayout="column" [formGroup]="clientFormGroup" style="margin-top: 1em">
    <div>
      <div fxLayout="row">
        <mat-form-field fxFill>
          <mat-label>{{ 'BUSINESS_NAME' | translate }}</mat-label>
          <input matInput formControlName="businessName" id="businessName" required />
          <mat-error *ngIf="checkError(clientFormGroup.get('businessName'))">
            <span
              *ngIf="clientFormGroup.get('businessName').hasError('required')">{{ 'ERROR.REQUIRED' | translate }}</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="50">
          <mat-label>{{ 'COUNTRY' | translate }}</mat-label>
          <mat-select formControlName="taxCodePrefix" id="taxCodePrefix" required>
            <mat-option *ngFor="let code of taxCode.taxCode" [value]="code.value">
              {{ code.country }} - {{ code.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <mat-label>{{ 'TAX_CODE' | translate }}</mat-label>
          <span matPrefix style="padding-right: 5px" [class.disabled-text]="this.data.client">
            {{ clientFormGroup.get('taxCodePrefix').value }}
          </span>
          <input matInput formControlName="taxCode" id="taxCode" />
          <mat-error *ngIf="checkError(clientFormGroup.get('taxCode'))">
            <span *ngIf="clientFormGroup.get('taxCode').hasError('required')">{{ 'ERROR.REQUIRED' | translate }}</span>
            <span
              *ngIf="clientFormGroup.get('taxCode').hasError('length')">{{ 'ERROR.TAX_CODE.FORMAT' | translate }}</span>
            <span
              *ngIf="clientFormGroup.get('taxCode').hasError('pattern')">{{ 'ERROR.TAX_CODE.FORMAT' | translate }}</span>
            <span
              *ngIf="clientFormGroup.get('taxCode').hasError('checksum')">{{ 'ERROR.TAX_CODE.FORMAT' | translate }}</span>
          </mat-error>
          <mat-error>
            <span
              *ngIf="clientFormGroup.get('taxCode').hasError('forbidden')">{{ 'ERROR.TAX_CODE.USED' | translate }}</span>
            <span *ngIf="clientFormGroup.hasError('taxCodeInvalid')">{{ 'ERROR.TAX_CODE.INVALID' | translate }}</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div>
      <h2>{{ 'OTHER.OTHER_DATA' | translate }}</h2>
      <div fxLayout="row" style="padding-bottom: 10px">
        <mat-checkbox formControlName="isNew" id="isNew">{{ 'OTHER.IS_NEW' | translate }}</mat-checkbox>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="50">
          <mat-label>{{ 'OTHER.AVERAGE_INVOICE_AMOUNT' | translate }}</mat-label>
          <input
            matInput
            currencyMask
            formControlName="averageInvoiceAmount"
            id="averageInvoiceAmount" />
          <span matSuffix>€</span>
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <mat-label>{{ 'OTHER.YEARLY_BILLED_AMOUNT' | translate }}</mat-label>
          <input
            matInput
            currencyMask
            formControlName="yearlyBilledAmount"
            id="yearlyBilledAmount" />
          <span matSuffix>€</span>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="50">
          <mat-label>{{ 'OTHER.EXISTING_INVOICE_TOTAL_AMOUNT' | translate }}</mat-label>
          <input
            matInput
            currencyMask
            formControlName="existingInvoiceTotalAmount"
            id="existingInvoiceTotalAmount" />
          <span matSuffix>€</span>
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <mat-label>{{ 'OTHER.PAYMENT_METHOD' | translate }}</mat-label>
          <mat-select formControlName="paymentMethod" id="paymentMethod">
            <mat-option [value]="null">-</mat-option>
            <mat-option value="bonifico">{{ 'OTHER.PM.TRANSFER' | translate }}
            </mat-option>
            <mat-option value="ricevuta_bancaria">{{ 'OTHER.PM.BANK_RECEIPT' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="50">
          <mat-label>{{ 'OTHER.PAYMENT_TERMS' | translate }}</mat-label>
          <mat-select formControlName="paymentTerms" id="paymentTerms">
            <mat-option [value]="null">-</mat-option>
            <mat-option value="30gg">{{ 'OTHER.PT.30GG' | translate }}</mat-option>
            <mat-option value="60gg">{{ 'OTHER.PT.60GG' | translate }}</mat-option>
            <mat-option value="90gg">{{ 'OTHER.PT.90GG' | translate }}</mat-option>
            <mat-option value="120gg">{{ 'OTHER.PT.120GG' | translate }}</mat-option>
            <mat-option value="150gg">{{ 'OTHER.PT.150GG' | translate }}</mat-option>
            <mat-option value="180gg">{{ 'OTHER.PT.180GG' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <mat-label>{{ 'OTHER.AVERAGE_PAYMENT_DELAY' | translate }}</mat-label>
          <input
            matInput
            type="number"
            formControlName="averagePaymentDelay"
            id="averagePaymentDelay" />
        </mat-form-field>
      </div>
    </div>
  </form>

  <mat-error *ngIf="errorSave">{{ 'ERROR.NOT_SAVE' | translate }}</mat-error>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="isSaving" class="btn-margin">
    <span>{{ 'BTN.CANCEL' | translate }}</span>
  </button>

  <button mat-button
          (click)="submit()"
          [disabled]="!clientFormGroup.valid"
          color="accent"
          class="btn-margin"
          fxLayoutAlign="center center">
    <ng-container *ngIf="!isSaving; else saving">{{ actionConfirm }}</ng-container>
    <ng-template #saving>
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        [diameter]="18"></mat-progress-spinner>
    </ng-template>
  </button>
</mat-dialog-actions>
